import {
  ModalActionDef,
  ModalDefine,
  ModalStatus
} from '@/libs/formHelper/modalForm/type'
import { MeritsList } from '@/api/merits/MeritsList'

export default function getModalDefine (view: any): ModalDefine<MeritsList> {
  const items = [
    // {
    //   title: '捐赠人',
    //   labelWidth: 150,
    //   col: { span: 12 },
    //   required: true,
    //   key: 'name',
    //   type: {
    //     module: 'text',
    //     maxlength: 10
    //   }
    // },
    // {
    //   title: '捐赠人手机',
    //   labelWidth: 150,
    //   col: { span: 12 },
    //   required: true,
    //   key: 'phone',
    //   type: {
    //     module: 'text',
    //     maxlength: 11
    //   }
    // },
    {
      title: '捐赠人金额',
      labelWidth: 150,
      col: { span: 12 },
      required: true,
      key: 'money',
      type: {
        module: 'text',
        maxlength: 11
      }
    },
    {
      title: '族谱成员',
      labelWidth: 150,
      col: { span: 12 },
      required: true,
      key: 'memberId',
      slot: 'memberId'
    },
    {
      title: '捐赠项目',
      labelWidth: 150,
      col: { span: 12 },
      required: true,
      key: 'donationId',
      slot: 'donationId'
    },
    {
      title: '捐赠时间',
      labelWidth: 150,
      col: { span: 12 },
      required: true,
      key: 'donationTime',
      type: {
        module: 'time'
      }
    }
  ]

  const actions: ModalActionDef<MeritsList>[] = [
    {
      key: 'create',
      title: '创建',
      type: 'submit',
      button: 'success',
      actionClose: true,
      modalStatus: ModalStatus.ADD,
      onClick: (item: MeritsList) => {
        return view.onInsertItem(item)
      }
    },
    {
      key: 'modi',
      title: '保存',
      type: 'submit',
      button: 'success',
      actionClose: true,
      modalStatus: ModalStatus.MODI,
      onClick: (item: MeritsList) => {
        return view.onUpdateItem(item)
      }
    }
  ]

  return {
    items,
    actions
  }
}
